import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LoggingIn = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // redirect after a short delay (optional)
    navigate("/");
  }, [navigate]);

  return <div>Logging in!</div>;
};

export default LoggingIn;
